// Gtag cmd
export const GTAG_CMD_EVENT = 'event';

// Gtag event names
export const GTAG_EVENT_NAMES = {
  IMP_BANNER_Z: 'imp_banner_z',
  IMP_TOP_BANNER: 'imp_top_banner',
  IMP_BOTTOM_BANNER: 'imp_bottom_banner',
  IMP_INDUSTRY_RECRUITING_ITEMS: 'imp_industry_recruiting_items',
  SAVE_PROFILE_INTERNS: 'save_profile_interns',
  SAVE_PROFILE_DEVELOPMENT_EXPERIENCE: 'save_profile_development_experience',
  SAVE_PROFILE_OFFERS: 'save_profile_offers',
  CLICK_INDUSTRY_RECRUITING_ITEMS: 'click_industry_recruiting_items',
  IMP_LINK_NOTICE: 'imp_link_notice',
  CLICK_LINK_NOTICE: 'click_link_notice',
  IMP_POST_REGISTER_ENTRY_PROMPT: 'imp_post_register_entry_prompt',
  IMP_ENTRY_DONE_RECOMMEND_PROMPT: 'imp_entry_done_recommend_prompt',
  IMP_AC_EMAIL_VERIFICATION_FORM: 'imp_ac_email_verification_form',
  CLICK_AC_EMAIL_VERIFICATION_SUBMIT: 'click_ac_email_verification_submit',
  CLICK_AC_EMAIL_VERIFICATION_RESEND: 'click_ac_email_verification_resend',
  IMP_UNIVERSITY_EMAIL_VERIFY_PROMPT: 'imp_university_email_verify_prompt',
  IMP_INTERVIEW_TRAINING_SIGNUP_PROMPT: 'imp_interview_training_signup_prompt',
  CLICK_INTERVIEW_TRAINING_SIGNUP: 'click_interview_training_signup',
  CLICK_INTERVIEW_TRAINING_LOGIN: 'click_interview_training_login',
} as const;

// Location: ページ単位で定義する
// https://www.notion.so/howtv/ffdaa6d4dee743c3b78fa485087d2228?v=9f6040757e5c411fb716d9d32ab45883&pvs=4
export const GTAG_LOCATION = {
  TOP: 'TOP',
  COMPANY_REPORTS: '/reports',
  SELECTION_REPORT: '/selection_report/[id]',
  PASSED_ES: '/passed_es/[id]',
  COLUMN_CATEGORIES: '/column/categories',
  TAG_COLUMN_LIST: '/column/tag/[tagName]',
  SUB_CATEGORY_COLUMN_LIST: '/column/category/[categoryName]/[subCategoryName]',
  COMPANY_COLUMN_LIST: '/columns/companies/[id]',
  SPONSORED_COLUMN_LIST: '/columns/sponsored',
  RANKING_COLUMN_LIST: '/columns/ranking',
  LATEST_COLUMN_LIST: '/columns/latest',
  MY_PAGE: '/mypage',
  WEB_SEMINAR: '/web_seminars/view/[id]',
  REPORTS_BY_INDUSTRY: '/reports/industry/[groupedIndustryId]',
  REPORTS_BY_DEPARTMENT: '/reports/department/[departmentId]',
  SEARCH: '/search',
  NOTIFICATIONS: '/mypage/notifications',
  ENGINEER: '/engineer',
  EDIT_AC_EMAIL: '/mypage/profile/edit/ac_email',
  EDIT_GENERAL_PROFILES: '/mypage/profile/edit/general',
  REGISTS_AC_EMAIL: '/regists/ac_email',
  STUDENT_VERIFICATION_REQUIRED: 'student_verification_required',
  UNIVERSITY_EMAIL_VERIFY_PROMPT: 'university_email_verify_prompt',
} as const;

// Make above object values type
export type GtagLocation = (typeof GTAG_LOCATION)[keyof typeof GTAG_LOCATION];
